export function prettyError(err) {
  if (!err) return "Unknown error";
  const data = err.response?.data;

  if (typeof data === "string") return data;
  if (data?.detail) return data.detail;

  // DRF field errors
  if (data && typeof data === "object") {
    const firstKey = Object.keys(data)[0];
    const v = data[firstKey];
    if (Array.isArray(v)) return `${firstKey}: ${v[0]}`;
    return `${firstKey}: ${String(v)}`;
  }

  return err.message || "Request failed";
}